<template>
  <div>
    <div class="excel-backdrop" @click.self="closePopupExcel">
      <div class="excel">
        <div class="excel-header">
          <div class="excel-close" @click="closePopupExcel">x</div>
          <slot name="title"></slot>
        </div>
        <div class="excel-body">
          <table id="excel-table">
            <tr style="position: sticky; top: 0">
              <th>年度</th>
              <th>總繳保費</th>
              <th>解約金</th>
              <th>報酬率</th>
            </tr>

            <tr v-for="item in JSON.parse(json_apiCalFormList)">
              <td>
                <span class="excel-tip" v-if="payYear === item.year">可領回</span>
                <span class="excel-tip" v-if="retireYear === item.year">退 休</span>
                {{ item.year }}</td>
              <td>{{ handleIfUSD(item.totalPaymentPremium) | currency }}</td>
              <td>{{ handleIfUSD(item.cancelPremium) | currency }}</td>
              <td>{{ returnRate(item.cancelPremium, item.totalPaymentPremium) }}%</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/popup_excel.css';
export default {
  name: 'popup-excel',
  props: {
    json_apiCalFormList: {
      type: String,
      default: '[]'
    },
    payYear: {
      type: Number,
      default: null
    },
    retireYear: {
      type: Number,
      default: null
    },
    isUSD: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      apiCalFormList: JSON.parse(this.json_apiCalFormList),
    }
  },
  methods: {
    closePopupExcel() {
      this.$emit('close');
    },
    handleIfUSD(value) {
      return this.isUSD ? value * 28 : value
    },
    returnRate(cancelPremium, totalPaymentPremium) {
      return Math.round((cancelPremium - totalPaymentPremium) / totalPaymentPremium * 100)
    }
  },
  filters: {
    currency(value) {
      var num = (value || 0).toString(),
          result = '';
      while (num.length > 3) {
        result = ',' + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
      }
      if (num) {
        result = num + result;
      }
      if (!result.indexOf('-,')) result = result.replace('-,', '-');
      return result;
    },
  },
};
</script>

<style></style>
